import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmsBlocked = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 8.75C12.25 9.0594 12.1271 9.3562 11.9083 9.575C11.6895 9.7938 11.3928 9.9167 11.0833 9.9167H4.0833L1.75 12.25V2.9167C1.75 2.6072 1.8729 2.3105 2.0917 2.0917C2.3105 1.8729 2.6072 1.75 2.9167 1.75H11.0833C11.3928 1.75 11.6895 1.8729 11.9083 2.0917C12.1271 2.3105 12.25 2.6072 12.25 2.9167V8.75Z",
			stroke: "currentColor",
			strokeWidth: 1.16667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.45898 1.45801L11.8145 11.3945",
			stroke: "var(--color-white, #fff)",
			strokeWidth: 2.91667,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.45898 1.45801L11.8145 11.3945",
			stroke: "currentColor",
			strokeWidth: 1.16667,
			strokeLinecap: "round"
		})
	]
});
export default SvgSmsBlocked;
